import React from 'react';
import BasePage from '../Routes/MainComponents/base/BasePage.page.jsx';

// Outside Pages
import AboutUs from '../Routes/AboutUs/AboutUs.page.jsx';
import Home from '../Routes/Home/Home.page.jsx';
import Resources from '../Routes/Resources/ResourcePage.page.jsx';
import OnlineTraining from '../OnlineTraining/CourseLists/TrainingOnlinePage.page.jsx';
import PrivacyPolicy from '../Routes/PrivacyPolicy/PrivacyPolicyPage.page.jsx';
import TermsAndConditions from '../Routes/Terms&Conditions/TermsAndConditionsPage.page.jsx';
import ContactUs from '../Routes/ContactUs/ContactUs.page.jsx';
import Shop from '../Routes/Shop/Shop.page.jsx';
import Certificate from '../Routes/Certificate/Certificate.page.jsx';
import ExploreProducts from '../Routes/ExploreProducts/ExploreProducts.page.jsx';
import News from '../Routes/News/News.page.jsx';
import Audits from '../Routes/Audits/Audits.page.jsx';
import Manuals from '../Routes/Manuals/Manuals.page.jsx';
import Forms from '../Routes/Forms/Forms.page.jsx';
import CompanyTraining from '../Routes/CompanyTraining/CompanyTraining.page.jsx';

// Payments
import BuyCourse from '../OnlineTraining/Purchase/BuyPage.page.jsx';

// Newsletter
import UnsubscribeFromNewsletter from '../Newsletter/UnsubscribeNewsletter.page.jsx';

// Authentication
import SignUpComponent from '../Authentication/SignupPage.page.jsx';
import LoginComponent from '../Authentication/LoginPage.page.jsx';
import ForgotPassword from '../Authentication/PasswordReset/ForgotPassword.page.jsx';
import ResetPassword from '../Authentication/PasswordReset/ResetPassword.page.jsx';
import CompanySignupPage from '../Authentication/CompSignUp/SignUpCompany.page.jsx';
import CheckoutAuth from '../OnlineTraining/Purchase/CheckoutAuth/CheckoutAuth.component.jsx';
// Payments
import PurchaseCompleted from '../OnlineTraining/Purchase/CompleteTransaction.page.jsx';

// Unauthorized Page
import Unauthorized from '../Unauthorized/UnauthorizedComponent.page.jsx';
import CancelledPayment from '../OnlineTraining/CanceledPayment/CancelledPayment.page.jsx';

export const publicRoutes = [
  { path: '', element: <Home /> },
  { path: 'about', element: <AboutUs /> },
  { path: 'terms-and-conditions', element: <TermsAndConditions /> },
  {
    path: 'unsubscribe-from-newsletter',
    element: <UnsubscribeFromNewsletter />,
  },
  { path: 'cart', element: <BuyCourse /> },
  { path: 'checkout/auth', element: <CheckoutAuth /> },
  { path: 'checkout/success', element: <PurchaseCompleted /> },
  { path: 'contact-us', element: <ContactUs /> },
  { path: 'privacy-policy', element: <PrivacyPolicy /> },
  { path: 'resources', element: <Resources /> },
  { path: 'news', element: <News /> },
  { path: 'shop', element: <Shop /> },
  { path: 'safety-audits', element: <Audits /> },
  { path: 'safety-manuals', element: <Manuals /> },
  { path: 'digital-safety-forms', element: <Forms /> },
  { path: 'company-training', element: <CompanyTraining /> },
  { path: 'explore-products', element: <ExploreProducts /> },
  { path: 'training', element: <OnlineTraining /> },
  { path: 'company-signup', element: <CompanySignupPage /> },
  { path: 'signup', element: <SignUpComponent /> },
  { path: 'checkout/cancel', element: <CancelledPayment /> },
  { path: 'certificate/:token', element: <Certificate /> },
  {
    path: 'login',
    element: <BasePage />,
    children: [
      { index: true, element: <LoginComponent /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password/:token', element: <ResetPassword /> },
    ],
  },
  { path: 'unauthorized', element: <Unauthorized /> },
];
